import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BiSolidUser } from "react-icons/bi";
import "./DocumentExpire.css";

const DocumentExpire = ({ data }) => {
  const [documentAlert] = useState(data);
  const navigate = useNavigate();

  const handleSearch = async (e, identify, relationUser) => {
    e.preventDefault();
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LEALTAD_SEARCH_USER_API}?id=${identify}&relation=${relationUser}`
      );
      if (res.data) {
        navigate("/lealtad/informe", { state: res.data });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el usuario.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const typeRisk = (alertUser) => {
    if (alertUser.risk === "Riesgo alto") {
      return <p className="riskhigh-lealtad">Riesgo Alto</p>;
    }

    if (alertUser.risk === "Riesgo medio") {
      return <p className="riskmid-lealtad">Riesgo Medio</p>;
    }

    if (alertUser.risk === "Riesgo bajo") {
      return <p className="risklow-lealtad">Riesgo Bajo</p>;
    }
  };
  return (
    <div className="boxtableDocumentAlert-lealtad">
      <table className="tableDocumentAlerts-lealtad">
        <thead>
          <tr>
            <th className="tableDocumentHeader-lealtad">Riesgo</th>
            <th className="tableDocumentHeader-lealtad">Usuario</th>
            <th className="tableDocumentHeader-lealtad">Dni / Cuit</th>
            <th className="tableDocumentHeader-lealtad">
              Relacion con la Mutual
            </th>
            <th className="tableDocumentHeader-lealtad">Tipo de Usuario</th>
            <th className="tableDocumentHeader-lealtad">Archivo</th>
            <th className="tableDocumentHeader-lealtad">
              Fecha de vencimiento
            </th>
            <th className="tableDocumentHeader-lealtad">Actualizar</th>
          </tr>
        </thead>
        <tbody>
          {documentAlert.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableDocumentDataRisk-lealtad">
                  {typeRisk(item)}
                </td>
                <td className="tableDocumentData-lealtad">{item.name}</td>
                <td className="tableDocumentData-lealtad">{item.identify}</td>
                <td className="tableDocumentData-lealtad">
                  {item.relationUser}
                </td>
                <td className="tableDocumentData-lealtad">{item.userType}</td>
                <td className="tableDocumentData-lealtad">{item.entityType}</td>
                <td className="tableDocumentData-lealtad">
                  {item.expirationDate}
                </td>
                <td className="tableDocumentData-lealtad">
                  <BiSolidUser
                    className="iconGrilla-lealtad "
                    onClick={(e) =>
                      handleSearch(e, item.identify, item.relationUser)
                    }
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentExpire;
